var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { getReq } from "../../request";
import { KB_ARTICLE_GET_PATH } from "../../globals";
import TimeAgo from "../../Timeago";
var ArticleV2 = function (_a) {
    var articleId = _a.articleId, onBackClick = _a.onBackClick;
    var titleRef = React.useRef(null);
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState({}), author = _c[0], setAuthor = _c[1];
    var _d = useState({}), article = _d[0], setArticle = _d[1];
    var handleScroll = function (e) {
        var target = e.target;
        if (titleRef.current) {
            if (target.scrollTop > titleRef.current.scrollHeight + 20) {
                titleRef.current.style.opacity = "1";
            }
            else
                titleRef.current.style.opacity = "0";
        }
    };
    useEffect(function () {
        setLoading(true);
        // Fetch article data
        var endpoint = "".concat(KB_ARTICLE_GET_PATH, "/").concat(articleId);
        getReq(endpoint, {})
            .then(function (response) {
            if (response && response.data) {
                setArticle(response.data);
                setAuthor(response.data.owner || {});
            }
            setLoading(false);
        })
            .catch(function (e) {
            console.log("Error fetching article:", e);
            setLoading(false);
        });
    }, [articleId]);
    return (_jsx("div", __assign({ className: "article-v2-container" }, { children: _jsx("div", __assign({ className: "chat__help chat__help-article" }, { children: !loading ? (_jsx("div", __assign({ className: "chat__conversation" }, { children: _jsx("div", __assign({ onScroll: handleScroll, className: "help__collections help__collections-article" }, { children: _jsxs("div", __assign({ className: "articlePage" }, { children: [_jsx("div", __assign({ className: "header" }, { children: _jsx("h1", __assign({ className: "title" }, { children: article.title })) })), _jsxs("div", __assign({ className: "body" }, { children: [_jsxs("div", __assign({ className: "desc" }, { children: [_jsx("p", { children: article.description }), author && author.name && (_jsxs("div", __assign({ className: "avatar" }, { children: [_jsx("div", { className: "avatar-img chat__all-messages-item-profile", style: {
                                                            backgroundImage: author.profile_img_url
                                                                ? "url(\"".concat(author.profile_img_url, "\")")
                                                                : 'none',
                                                        } }), _jsx("div", __assign({ className: "avatar__info" }, { children: _jsxs("span", { children: [_jsxs("div", { children: ["Written by ", author.name] }), article.updated_time ? (_jsxs("div", { children: ["Updated over", " ", _jsx(TimeAgo, { date: article.updated_time * 1000 })] })) : (_jsxs("div", { children: ["Posted over", " ", _jsx(TimeAgo, { date: article.created_time * 1000 })] }))] }) }))] })))] })), article.content && (_jsx("article", { dangerouslySetInnerHTML: { __html: article.content }, className: "article" }))] }))] })) })) }))) : (_jsx("div", __assign({ className: "pad-content" }, { children: _jsxs("div", __assign({ className: "chat__form-loader1" }, { children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {}), _jsx("span", {})] })) }))) })) })));
};
export default ArticleV2;
